import React, { Component } from "react";
import { Container, Grid } from "@material-ui/core";
import FacilityDescription from "./FacilityDescription";
import { GetData } from "../../api/service";
import "../section-sidebar.css";

const list = [
  {
    title: "Library",
    link: "/facility/library",
  },
  // {
  //   title: "Boys Hostel",
  //   link: "/facility/boyshostel",
  // },
  // {
  //   title: "Girls Hostel",
  //   link: "/facility/girlshostel",
  // },
  // {
  //   title: "CIF",
  //   link: "/facility/cif",
  // },
  {
    title: "Canteen",
    link: "/facility/canteen",
  },
  {
    title: "Auditorium",
    link: "/facility/auditorium",
  },
  {
    title: "Conference Hall",
    link: "/facility/conferencehall",
  },
  {
    title: "Gymnasium",
    link: "/facility/gymnasium",
  },
  // {
  //   title: "ICGC",
  //   link: "/facility/icgc",
  // },
];

class PanduFacility extends Component {
  state = {
    link: "",
    list: [],
    isListLoaded: false,
    query: "",
  };
  componentDidMount() {
    let link = this.props.match.params.link;
    this.setState({
      link: link,
    });

    this.loadData();
  }

  createBlogLink = (title) => {
    // Convert the title to lowercase
    let lowerCaseTitle = title.toLowerCase();
    
    // Replace spaces and special characters with hyphens
    let urlFriendlyTitle = lowerCaseTitle.replace(/[^a-z0-9]+/g, '-');
    
    // Remove leading or trailing hyphens
    urlFriendlyTitle = urlFriendlyTitle.replace(/^-+|-+$/g, '');
    
    return urlFriendlyTitle;
}


  loadData = () => {
    GetData(`/getcollegefacilitylist`)
    .then((resp) => {
      this.setState({
        list: resp.map((el) => ({
          ...el,
          link: `${this.createBlogLink(el.title)}-${el.id}`
        })),
        isListLoaded: true
      })
    })
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.match.params.link != this.props.match.params.link) {
      let link = this.props.match.params.link;
      this.setState({
        link: link,
      });
    }
  }

  render() {
    const query = this.state.query.trim().toLowerCase();
    const filtered = query
      ? this.state.list.filter((el) =>
          (el.title || "").toLowerCase().includes(query)
        )
      : this.state.list;

    return (
      <div className="snav-wrap">
        <Container style={{ minHeight: "500px" }}>
          <Grid container spacing={4}>
            <Grid item xs={12} sm={12} md={3} lg={3}>
              <nav className="snav-side">
                <div className="snav-side-head">Facilities</div>
                <div className="snav-search">
                  <div className="snav-search-field">
                    <span className="fa fa-search" aria-hidden="true" />
                    <input
                      type="text"
                      className="snav-search-input"
                      placeholder="Search facilities..."
                      value={this.state.query}
                      onChange={(e) =>
                        this.setState({ query: e.target.value })
                      }
                    />
                  </div>
                </div>
                <ul className="snav-side-list">
                  {filtered.length === 0 ? (
                    <li className="snav-side-empty">
                      {this.state.isListLoaded
                        ? "No matching items"
                        : "Loading..."}
                    </li>
                  ) : (
                    filtered.map((el, index) => (
                      <li
                        key={index}
                        className={`snav-side-item${
                          el.link === this.state.link ? " active" : ""
                        }`}
                        onClick={() => this.props.history.push(el.link)}
                      >
                        <span className="snav-dot" />
                        {el.title}
                      </li>
                    ))
                  )}
                </ul>
              </nav>
            </Grid>

            <Grid item xs={12} sm={12} md={9} lg={9}>
              <FacilityDescription type={this.state.link} />
            </Grid>
          </Grid>
        </Container>
      </div>
    );
  }
}

export default PanduFacility;
